import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { FormFillService } from '../global-services/form-fill.service';

@Injectable({ providedIn: 'root' })
export class FormFillGuard implements CanActivate {
  constructor(
    private router: Router,
    private formFillService: FormFillService,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const accessToken = route.queryParams['token'];
    const assignmentId = route.params['assignmentId'];

    if (!accessToken || !assignmentId) {
      this.router.navigate(['/form-fill-error/unknown']);
      return false;
    }

    const response = await this.formFillService.checkFormFillStatus(assignmentId, accessToken);

    if (response.status !== 'READY') {
      this.router.navigate(['/form-fill-error/unknown']);
      return false;
    }

    return true;
  }
}
